import { page, type FeatureRoutes } from "@/app/feature";

// No `shows(...)` handles: battles and cards are live areas, so no demo badge, and this file is on the first load.
const pvp = () => import("./pvp/pages");

export const routes: FeatureRoutes = {
  shell: [
    { path: "battles", lazy: page(() => import("./BattlesPage")) },
    { path: "battles/team", lazy: page(() => import("./TeamPage")) },
    { path: "battles/pvp", lazy: page(() => pvp().then((m) => ({ default: m.QueuePage }))) },
  ],
  // The board takes the whole screen: no tab bar under the action buttons.
  fullscreen: [
    { path: "battles/:battleId", lazy: page(() => import("./BattlePage")) },
    { path: "battles/pvp/:matchId", lazy: page(() => pvp().then((m) => ({ default: m.PvpBattlePage }))) },
    // Dev only: one exchange of the animation grammar, any bucket and element. Dropped from production builds.
    ...(import.meta.env.DEV ? [{ path: "dev/battle-fx", lazy: page(() => import("./arena/FxLab")) }] : []),
  ],
};
